import {periods} from 'logic/Dashboard/usePeriod'
import useActivities from 'logic/Dashboard/useActivities'
import {useCallback, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useIntercomIntegration} from 'services/utils/useIntercomIntegration'
import {useGetCurrentUserQuery} from 'store/Store'
import analyticsService from 'services/analytic'

const useDashboardScreen = () => {
    const {data: user} = useGetCurrentUserQuery('')
    const {updateData} = useIntercomIntegration()

    const navigate = useNavigate()

    const [period, setPeriod] = useState(periods.fromStartOfMonth())
    const [selectedStatus, setSelectedStatus] = useState('done')

    const {status, tableData, chartData, isLoading} = useActivities(period)

    const clickAllClients = useCallback(() => {
        navigate('/clients')
    }, [navigate])

    useEffect(() => {
        if (user) {
            updateData(user)
        }
    }, [user, updateData])

    const selectPeriod = useCallback((p) => {
        setPeriod(p)
        analyticsService.homePressed('date', {period: p.label})
    }, [])

    const selectStatus = useCallback((status) => {
        setSelectedStatus(status)
        analyticsService.homePressed(`request_${status}`)
    }, [])

    return {
        user,
        selectPeriod,
        selectedStatus,
        selectStatus,
        status,
        tableData,
        chartData,
        isLoading,
        clickAllClients,
    }
}

export default useDashboardScreen
